import { sortAlphabetically } from './sortUtil';
import { ADWORDS_DISPLAY_NAME } from './reportsConsts';

export const NETWORKS_SPECIAL_DISPLAY_NAME_MAPPING = {
    adwords: ADWORDS_DISPLAY_NAME,
    facebook: 'Facebook (Meta Ads)',
    applesearchads: 'Apple Search Ads (Apple Ads)',
    doubleclickdcm: 'Double Click DCM (Google - CM360)',
    doubleclickdbm: 'Double Click DBM (Google - DV360)',
    searchads360: 'Search Ads 360 (Google - SA360)',
    verizon: 'Verizon Media (Yahoo DSP)',
    aarki: 'RZR (Aarki)',
    yahoo_japan_ydn: 'LY Ads (Yahoo Japan)',
};

export const NETWORKS_SPECIAL_ORIGINAL_DISPLAY_NAME_MAPPING = {
    adwords: 'AdWords',
    facebook: 'Facebook',
    applesearchads: 'Apple Search Ads',
    doubleclickdcm: 'Double Click DCM',
    doubleclickdbm: 'Double Click DBM',
    searchads360: 'Search Ads 360',
    verizon: 'Verizon Media',
    aarki: 'Aarki',
    yahoo_japan_ydn: 'Yahoo Japan (YDN)',
};

export const getAdnetworkDisplayName = (name, displayName) =>
    NETWORKS_SPECIAL_DISPLAY_NAME_MAPPING[name] || displayName?.trim();

// Maps source filter options' labels ({ value: name, label: display_name }) through the display-name map.
export const mapSourceOptionLabels = options =>
    options.map(option => ({ ...option, label: getAdnetworkDisplayName(option.value, option.label) }));

// Maps a source's raw backend display name ('Facebook') to its mapped form ('Facebook (Meta Ads)').
// Idempotent: already-mapped or unmapped names are returned unchanged. `available_sources` is always
// mapped (see sagas/fields.js), so consumers normalize the raw side before comparing.
const ORIGINAL_TO_SPECIAL_DISPLAY_NAME = Object.entries(NETWORKS_SPECIAL_ORIGINAL_DISPLAY_NAME_MAPPING).reduce(
    (acc, [name, originalDisplayName]) => {
        acc[originalDisplayName] = NETWORKS_SPECIAL_DISPLAY_NAME_MAPPING[name];
        return acc;
    },
    {}
);

export const normalizeSourceDisplayName = displayName => ORIGINAL_TO_SPECIAL_DISPLAY_NAME[displayName] || displayName;

// Resolves whether a stored filter tag refers to a given filter value. A source tag can arrive as the
// machine name ('facebook'), the raw display name ('Facebook'), or the mapped name ('Facebook (Meta Ads)'),
// so for the source dimension we widen matching to cover all three. Every other dimension keeps the strict
// display_name match it had before, so a tag can never bind to a different value via its machine name.
// Shared by formattedFilters and getCalcFilterForType so the two lookups can't drift apart.
export const sourceTagMatchesValue = (value, tag, isSourceField = false) =>
    isSourceField
        ? value.name === tag || normalizeSourceDisplayName(value.display_name) === normalizeSourceDisplayName(tag)
        : value.display_name === tag;

const formatAdNetworkObject = (id, name, displayName, logoPath, disabled) => ({
    id,
    value: name,
    logoPath,
    label: getAdnetworkDisplayName(name, displayName),
    isDisabled: disabled,
});

export const getAdNetworkOptions = adNetworks => {
    return Object.keys(adNetworks)
        .map(key => {
            const adNetwork = adNetworks[key];
            return formatAdNetworkObject(
                adNetwork.id,
                adNetwork.name,
                adNetwork.display_name,
                adNetwork.logo_path,
                adNetwork.disabled
            );
        })
        .sort(({ label: label1 }, { label: label2 }) => sortAlphabetically(label1, label2))
        .sort(a => (a.isDisabled ? 1 : -1));
};

export const getPartnersOptions = partners => {
    return partners
        .map(({ id, name, displayName, logoPath }) => formatAdNetworkObject(id, name, displayName, logoPath))
        .sort(({ label: label1 }, { label: label2 }) => sortAlphabetically(label1, label2));
};
